import qs from "qs";
import axios from "../helpers/axios";

import {
  LedgerBalanceItem,
  LedgerBalanceResult,
  LedgerBalanceSearchQuery,
  LedgerBalanceCursor,
} from "../types/ledgerBalances";

type GetLedgerBalancesQuery = {
  pageSize: number;
  searchQuery: LedgerBalanceSearchQuery;
  cursor?: LedgerBalanceCursor;
};

type LedgerBalancesResponse = {
  items: LedgerBalanceItem[];
  nextCursor: LedgerBalanceCursor | null;
};

export const getLedgerBalances = async ({
  pageSize,
  searchQuery,
  cursor,
}: GetLedgerBalancesQuery): Promise<LedgerBalanceResult> => {
  const params = {
    country: searchQuery.country,
    currency: searchQuery.currency,
    sortBy: searchQuery.sortBy,
    sortDir: searchQuery.sortDir,
    totalOp: searchQuery.totalOp,
    totalAmount: searchQuery.totalAmount,
    availableOp: searchQuery.availableOp,
    availableAmount: searchQuery.availableAmount,
    limit: pageSize + 1,
    cursorSortValue: cursor?.sortValue,
    cursorAccountId: cursor?.accountId,
  };

  const { data } = await axios.get<LedgerBalancesResponse>(
    "/admin/ledger/balances",
    {
      params,
      paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
    }
  );

  // The body is { items, nextCursor }. limit is pageSize + 1, so the extra
  // row is only a hasMore probe. nextCursor points at that extra row; the
  // page builds its own cursor from the last row it actually shows.
  const fetched = Array.isArray(data?.items) ? data.items : [];
  const hasMore = fetched.length > pageSize;

  return {
    items: hasMore ? fetched.slice(0, pageSize) : fetched,
    pageSize,
    hasMore,
  };
};
